import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ServiceCard = ({ service }) => {
  return (
    <Card
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <IconContainer aria-hidden="true">
        {service.icon}
      </IconContainer>

      <ServiceTitle>{service.title}</ServiceTitle>
      <ServiceDescription>{service.description}</ServiceDescription>

      <FeaturesList>
        {service.features.map((feature, index) => (
          <FeatureItem key={index}>
            <FeatureDot />
            {feature}
          </FeatureItem>
        ))}
      </FeaturesList>
    </Card>
  );
};

const Card = styled(motion.div)`
  background: var(--glass-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-border);
  box-shadow: var(--glass-shadow);
  border-radius: var(--border-radius);
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.35s ease;
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(124, 58, 237, 0.2);
    border-color: rgba(124, 58, 237, 0.4);
  }
`;

const IconContainer = styled.div`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  max-width: 60px;
  max-height: 60px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: linear-gradient(135deg, #7C3AED, #2563EB);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: white;
  font-size: 1.8rem;
  flex: none;
  line-height: 1;
  overflow: hidden;
`;

const ServiceTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: var(--text-primary-dark);
  .light & { color: var(--text-primary-light); }
`;

const ServiceDescription = styled.p`
  color: var(--text-secondary-dark);
  margin-bottom: 1.5rem;
  line-height: 1.6;
  .light & { color: var(--text-secondary-light); }
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: auto;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  font-size: 0.95rem;
  color: var(--text-primary-dark);
  .light & { color: var(--text-primary-light); }
`;

const FeatureDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7C3AED, #2563EB);
  margin-right: 0.8rem;
  flex-shrink: 0;
`;

export default ServiceCard;